import type { PaletteMode } from '@mui/material';
import { PALETTE_MODE } from './theme.constants';
import {
    rgba,
    OPACITY,
    WHITE,
    SLATE_50,
    SLATE_100,
    SLATE_200,
    SLATE_400,
    SLATE_600,
    SLATE_800,
    SLATE_900,
    SLATE_950,
    INDIGO_400,
    INDIGO_500,
    INDIGO_600,
    INDIGO_800,
    VIOLET_600,
    VIOLET_800,
    PURPLE_400,
    PURPLE_500,
    RED_400,
    RED_500,
    RED_600,
    RED_800,
    AMBER_500,
    AMBER_600,
} from './colors';

// TODO: update to use dark-mode colors from figma
const darkMode = {
    primary: {
        main: INDIGO_500,
        light: INDIGO_400,
        dark: INDIGO_600,
        contrastText: WHITE,
    },
    secondary: {
        main: PURPLE_500,
        light: PURPLE_400,
        dark: VIOLET_600,
        contrastText: WHITE,
    },
    background: {
        default: SLATE_900,
        paper: SLATE_800,
    },
    text: {
        primary: SLATE_50,
        secondary: SLATE_400,
    },
    error: {
        main: RED_500,
        light: RED_400,
        dark: RED_600,
        contrastText: WHITE,
    },
    warning: {
        main: AMBER_500,
    },
    divider: rgba(SLATE_400, OPACITY.soft),
    gradients: {
        button: `linear-gradient(90deg, ${INDIGO_500} 0%, ${PURPLE_500} 100%)`,
        layout: `linear-gradient(180deg, ${SLATE_900} 0%, ${SLATE_950} 100%)`,
        header: `linear-gradient(90deg, ${SLATE_800} 0%, ${SLATE_900} 100%)`,
    },
};

// TODO: update to use light-mode colors from figma
const lightMode = {
    primary: {
        main: INDIGO_600,
        light: INDIGO_500,
        dark: INDIGO_800,
        contrastText: WHITE,
    },
    secondary: {
        main: VIOLET_600,
        light: PURPLE_500,
        dark: VIOLET_800,
        contrastText: WHITE,
    },
    background: {
        default: SLATE_50,
        paper: WHITE,
    },
    text: {
        primary: SLATE_900,
        secondary: SLATE_600,
    },
    error: {
        main: RED_600,
        light: RED_500,
        dark: RED_800,
        contrastText: WHITE,
    },
    warning: {
        main: AMBER_600,
    },
    divider: rgba(SLATE_900, OPACITY.muted),
    gradients: {
        button: `linear-gradient(90deg, ${INDIGO_600} 0%, ${VIOLET_600} 100%)`,
        layout: `linear-gradient(180deg, ${SLATE_50} 0%, ${SLATE_200} 100%)`,
        header: `linear-gradient(90deg, ${WHITE} 0%, ${SLATE_100} 100%)`,
    },
};

export function getDesignTokens(mode: PaletteMode) {
    return {
        palette: {
            mode,
            ...(mode === PALETTE_MODE.DARK ? darkMode : lightMode),
        },
    };
}
